import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { Link } from './link';
import { LinkAdv as Component } from './components/link-adv';
import { getNewHref } from './helpers/get-new-href';
import type { ILinkAdvDependencies, ILinkAdvSummaryProps } from './models';

export const LinkPid = createWidget<ILinkAdvDependencies, ILinkAdvSummaryProps>({
    getNewHref,
    Link,
})(Component);
